

export const MarginUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M0 20 h 16 l 5 -5 h -16 Z" stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 12 v -7 l 4 -4 h 7 v 7 l -4 4 v -7 l 4 -4 m -4 4 h -7 m 0 7 h 7" stroke="#838280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}